import React, { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Checkbox } from './ui/checkbox';

export const NextStepsEditor = ({ steps, onChange }) => {
  const [texto, setTexto] = useState('');
  const [fecha, setFecha] = useState('');

  const add = () => {
    if (!texto.trim()) return;
    onChange([...steps, { id: crypto.randomUUID(), texto: texto.trim(), fecha: fecha || null, hecho: false }]);
    setTexto(''); setFecha('');
  };
  const patch = (id, p) => onChange(steps.map((s) => (s.id === id ? { ...s, ...p } : s)));

  return (
    <div className="space-y-2" data-testid="next-steps-editor">
      {steps.map((s) => (
        <div key={s.id} className="flex items-center gap-2 group" data-testid={`next-step-${s.id}`}>
          <Checkbox checked={s.hecho} onCheckedChange={(v) => patch(s.id, { hecho: !!v })} data-testid={`next-step-done-${s.id}`} />
          <span className={`flex-1 text-sm ${s.hecho ? 'line-through text-muted-foreground' : ''}`}>{s.texto}</span>
          <Input type="date" value={s.fecha || ''} onChange={(e) => patch(s.id, { fecha: e.target.value || null })} className="h-8 w-[150px] text-xs" data-testid={`next-step-date-${s.id}`} />
          <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => onChange(steps.filter((x) => x.id !== s.id))} data-testid={`next-step-delete-${s.id}`}>
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      ))}
      <div className="flex items-center gap-2">
        <Input value={texto} onChange={(e) => setTexto(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && add()} placeholder="Ej.: Enviar propuesta" className="h-9" data-testid="next-step-text-input" />
        <Input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} className="h-9 w-[150px]" data-testid="next-step-date-input" />
        <Button size="sm" variant="secondary" onClick={add} data-testid="next-step-add-btn"><Plus className="w-4 h-4" /></Button>
      </div>
    </div>
  );
};
